import { SignalServiceBase } from "cayo.ui";

type FilterSignals = "filterChanged" | "filterSelected";

export const filterSignalsService = new SignalServiceBase<FilterSignals, any>();
